module.exports = __webpack_public_path__ + "img/biaoqian_qiangxianjiuyuan.368ab943.png";